module.exports = __webpack_public_path__ + "img/betsy-ross.366deadd.png";